/**
 * @generated SignedSource<<0ec25bbe992a9ad6553717102aff243b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartSubmissionPageQuery$variables = {
  submissionId: string;
};
export type StartSubmissionPageQuery$data = {
  readonly landlordOnboardingSubmission: {
    readonly " $fragmentSpreads": FragmentRefs<"StartPostAuthFlow_submission">;
  } | null | undefined;
};
export type StartSubmissionPageQuery = {
  response: StartSubmissionPageQuery$data;
  variables: StartSubmissionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "submissionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartSubmissionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StartPostAuthFlow_submission"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StartSubmissionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordAgentSearch",
            "kind": "LinkedField",
            "name": "agentSearch",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branchesFound",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branchesCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeAll",
                    "value": true
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "GOOGLE_RATING"
                  }
                ],
                "concreteType": "LandlordAgentFinderResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDiscoveredBranch",
                    "kind": "LinkedField",
                    "name": "branch",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "strengths",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDiscoveredBranchFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDiscoveredBranchFee",
                            "kind": "LinkedField",
                            "name": "management",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percent",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "feesIncludeVat",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "distanceMeters",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDiscoveredBranchEnrichmentRun",
                    "kind": "LinkedField",
                    "name": "enrichmentRun",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": "results(includeAll:true,sort:\"GOOGLE_RATING\")"
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordAreaPreview",
            "kind": "LinkedField",
            "name": "areaPreview",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formattedAddress",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "situation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceWanted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termsStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordOnboardingContractDocument",
            "kind": "LinkedField",
            "name": "contractDocuments",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordNegotiationRequest",
            "kind": "LinkedField",
            "name": "negotiationRequest",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDiscoveredBranch",
                "kind": "LinkedField",
                "name": "consentedBranches",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98c99b0777ba855e2811bac6dab14b7b",
    "id": null,
    "metadata": {},
    "name": "StartSubmissionPageQuery",
    "operationKind": "query",
    "text": "query StartSubmissionPageQuery(\n  $submissionId: ID!\n) {\n  landlordOnboardingSubmission(id: $submissionId) {\n    ...StartPostAuthFlow_submission\n    id\n  }\n}\n\nfragment StartContractDocuments_submission on LandlordOnboardingSubmission {\n  id\n  contractDocuments {\n    id\n    fileName\n  }\n}\n\nfragment StartNegotiationShortlistBranch_result on LandlordAgentFinderResult {\n  distanceMeters\n  enrichmentRun {\n    status\n    id\n  }\n  branch {\n    name\n    googleRating\n    googleReviewCount\n    strengths\n    fees {\n      management {\n        percent\n      }\n      feesIncludeVat\n    }\n    id\n  }\n}\n\nfragment StartNegotiationShortlistConsent_search on LandlordAgentSearch {\n  status\n  results(includeAll: true, sort: GOOGLE_RATING) {\n    __typename\n  }\n}\n\nfragment StartNegotiationShortlistConsent_submission on LandlordOnboardingSubmission {\n  id\n  areaPreview {\n    formattedAddress\n    id\n  }\n  negotiationRequest {\n    __typename\n    id\n  }\n}\n\nfragment StartNegotiationShortlistStatus_search on LandlordAgentSearch {\n  status\n  branchesFound\n  branchesCompleted\n  results(includeAll: true, sort: GOOGLE_RATING) {\n    __typename\n  }\n}\n\nfragment StartNegotiationShortlistStatus_submission on LandlordOnboardingSubmission {\n  areaPreview {\n    formattedAddress\n    id\n  }\n}\n\nfragment StartNegotiationShortlist_search on LandlordAgentSearch {\n  status\n  results(includeAll: true, sort: GOOGLE_RATING) {\n    branch {\n      id\n    }\n    ...StartNegotiationShortlistBranch_result\n  }\n  ...StartNegotiationShortlistConsent_search\n  ...StartNegotiationShortlistStatus_search\n  ...useStartNegotiationShortlist_search\n}\n\nfragment StartNegotiationShortlist_submission on LandlordOnboardingSubmission {\n  serviceWanted\n  areaPreview {\n    formattedAddress\n    id\n  }\n  ...StartNegotiationShortlistConsent_submission\n  ...StartNegotiationShortlistStatus_submission\n  ...useStartNegotiationShortlist_submission\n}\n\nfragment StartNegotiationTerms_submission on LandlordOnboardingSubmission {\n  id\n  situation\n  serviceWanted\n  tenantStatus\n  termsStatus\n  contractDocuments {\n    id\n  }\n  ...StartContractDocuments_submission\n}\n\nfragment StartPostAuthFlowLoaded_search on LandlordAgentSearch {\n  ...StartPostAuthFlowOffer_search\n  ...StartNegotiationShortlist_search\n}\n\nfragment StartPostAuthFlowLoaded_submission on LandlordOnboardingSubmission {\n  id\n  areaPreview {\n    formattedAddress\n    id\n  }\n  ...StartNegotiationTerms_submission\n  ...StartNegotiationShortlist_submission\n}\n\nfragment StartPostAuthFlowOffer_search on LandlordAgentSearch {\n  status\n  branchesFound\n  branchesCompleted\n}\n\nfragment StartPostAuthFlow_submission on LandlordOnboardingSubmission {\n  agentSearch {\n    ...StartPostAuthFlowLoaded_search\n    id\n  }\n  ...StartPostAuthFlowLoaded_submission\n  ...useStartPostAuthFlowPhase_submission\n}\n\nfragment useStartNegotiationShortlist_search on LandlordAgentSearch {\n  status\n  results(includeAll: true, sort: GOOGLE_RATING) {\n    branch {\n      id\n    }\n  }\n}\n\nfragment useStartNegotiationShortlist_submission on LandlordOnboardingSubmission {\n  id\n  negotiationRequest {\n    __typename\n    consentedBranches {\n      id\n    }\n    id\n  }\n}\n\nfragment useStartPostAuthFlowPhase_submission on LandlordOnboardingSubmission {\n  situation\n  tenantStatus\n  termsStatus\n  negotiationRequest {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "641fd443ee43f205033d10ac7ece0185";

export default node;
